<template>
  <div>
    <!--头部-->
    <div class="bg" id="bg">
      <div class="logo" @click="goHome">
        <img src="../../../static/images/base/GYWM-32.png" alt />
      </div>
      <div class="btnBox" @mouseenter="open()">
        <div class="hengFlex">
          <!--<template v-if="hasOpen">-->
          <p
            v-for="(item, index) in CAE"
            :class="item.id == actived ? 'activedStyle' : ''"
            @click="changeCAE(item.id)"
            :key="index"
          >
            {{ item.name }}
          </p>
          <!--</template>-->
          <div class="meS" @click="changeMenu()">
            <img src="../../../static/images/base/iconMenu.png" alt />
          </div>
        </div>
      </div>
    </div>
    <div class="menuTem" @mouseleave="close()" :class="{ openMean: hasOpen }">
      <div class="menubox">
        <div v-for="(item, index) in menuList" :key="index" class="firstBox">
          <div
            class="firstTit"
            style="position: relative"
            :class="item.id === menuActive ? 'activedMenu' : ''"
            @mouseenter="openItem(item, item.id)"
            @mouseleave="colseItem(item, item.id)"
            @click="changeMenuIndex(item, item.id)"
          >
            {{ isChinese ? item.cName : item.eName }}
            <!-- 子内容收缩板 -->
            <div>
              <template v-if="item.children && item.children.length > 0">
                <div
                  v-for="(it, inx) in item.children"
                  class="childBox"
                  :class="item.hasActived ? 'openChild' : 'closeChild'"
                  :key="inx"
                >
                  <p v-if="inx==0" class="childrenTitT">
                    {{ isChinese ? "热浸锌涂层" : "Hot-dip Galvanized" }}
                  </p>
                  <p v-else class="childrenTitT">
                    {{ isChinese ? "锌铝涂覆涂层" : "Zinc-flake Coating" }}
                  </p>
                  <div
                  v-for="(c, inx) in it"
                  class="childBox"
                  @click="goChildRouter(c)"
                  
                  :key="inx"
                >
                  <p class="childrenTit">
                    {{ isChinese ? c.title : c.titleEn }}
                  </p>
                </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      hasOpen: false,
      isChinese: true,
      actived: 1,
      hiddenNav: false,
      CAE: [
        { name: "中", id: 1 },
        { name: "EN", id: 2 },
      ],
      menuActive: 1,
      menuList: [
        {
          cName: "首页",
          eName: "Home",
          id: 1,
          routerUrl: "/",
          children: [],
          hasActived: false,
        },
        {
          cName: "关于计氏",
          eName: "About Jishi",
          id: 2,
          routerUrl: "/AboutUs",
          children: [],
          hasActived: false,
        },
        {
          cName: "解决方案",
          eName: "Solution",
          id: 3,
          routerUrl: "/Solution",
          children: [],
          hasActived: false,
        },
        {
          cName: "新闻中心",
          eName: "News Center",
          id: 4,
          routerUrl: "/News",
          children: [],
          hasActived: false,
        },
        {
          cName: "下载中心",
          eName: "Download Center",
          id: 5,
          routerUrl: "/downLoadCenter",
          children: [],
          hasActived: false,
        },
        {
          cName: "联系我们",
          eName: "Contact Us",
          id: 6,
          routerUrl: "/ContactUs",
          children: [],
          hasActived: false,
        },
      ],
    };
  },
  computed: {
    setCAE() {
      return this.$store.state.cAeSatus;
    },
  },

  created() {
    this.getMenuItem();
    this.isChinese = this.$store.state.cAeSatus === 1 ? true : false;
    this.actived = this.$store.state.cAeSatus;
    this.menuActive = this.$store.state.activedMenuIndex;
  },
  mounted() {
    $(window).scroll(function (event) {
      var oTop =
        document.body.scrollTop == 0
          ? document.documentElement.scrollTop
          : document.body.scrollTop;
      if (oTop < 5) {
        $("#bg").css("background-color", "rgba(0,0,0,0)");
      } else {
        $("#bg").css("background-color", "rgba(0,0,0,.5)");
      }
    });
  },
  watch: {
    setCAE(newVal) {
      this.isChinese = newVal === 1 ? true : false;
      this.actived = newVal === 1 ? 1 : 2;
    },
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/" });
      this.menuActive = 1;
      this.$store.commit("setActiviedMenuIndex", 1);
    },
    open() {
      this.hasOpen = true;
    },
    close() {
      this.hasOpen = false;
    },
    changeCAE(num) {
      this.actived = num;
      if (num === 1) {
        this.isChinese = true;
        this.$store.commit("setCAE", 1);
      } else if (num === 2) {
        this.isChinese = false;
        this.$store.commit("setCAE", 2);
      }
    },
    getMenuItem() {
      // 获取解决方案 的菜单
      this.$http.get("/jishi/api/case/all", {}).then(
        function (res) {
          if (res && res.data.code === 0) {
            let resdata = res.data;
            this.menuList[2].children = resdata.data;
          }
        }.bind(this)
      );
    },
    changeMenu() {
      this.hasOpen = !this.hasOpen;
    },
    changeMenuIndex(item, index) {
      // 跳转
      this.$router.push({ path: item.routerUrl });
      // 判断当前传入的menuItem 是否有children
      this.menuActive = index;
      this.$store.commit("setActiviedMenuIndex", index);
      if (item.children && item.children.length > 0) {
        this.menuList.forEach((a) => {
          if (a.id === index) {
            a.hasActived = true;
          } else {
            a.hasActived = false;
          }
        });
      } else {
        this.menuList.forEach((a) => {
          a.hasActived = false;
        });
      }
    },
    openItem(item, index) {
      if (item.children && item.children.length > 0) {
        this.menuList.forEach((a) => {
          if (a.id === index) {
            a.hasActived = true;
          } else {
            a.hasActived = false;
          }
        });
      }
    },
    colseItem(item, index) {
      if (item.children && item.children.length > 0) {
        this.menuList.forEach((a) => {
          if (a.id === index) {
            a.hasActived = false;
          } else {
            a.hasActived = false;
          }
        });
      }
    },
    goChildRouter(data) {
      let routeData = this.$router.resolve({
        path: "/solutionMore/id=" + data.id,
        query: { title: data.business },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="stylus" scoped>
img {
  width: 100%;
}

.bg {
  position: fixed;
  z-index: 999;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 0;
}

.bg1 {
  position: fixed;
  z-index: 999;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 0;
}

.logo {
  z-index: 999;
  width: 10vw;
  margin-left: 30px;
}

.btnBox {
  z-index: 999;
  margin-right: 30px;

  .hengFlex {
    display: flex;
    justify-content: right;
    align-items: center;
    z-index: 2;

    p {
      display: inline-block;
      padding: 3px;
      border: 1px solid white;
      margin-right: 15px;
      color: white;
      cursor: pointer;
      font-size: 12px;
    }

    .activedStyle {
      border: 1px solid #EDAC1A;
      color: #EDAC1A;
    }

    .meS {
      width: 26px;
      height: 24px;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.menuTem {
  animation: slide-out-left 0.5s;
  animation-fill-mode: forwards;
  position: fixed;
  right: 0;
  width: 350px;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 998;

  .menubox {
    color: white;
    width: 140px;
    margin-top: 10vw;
    margin-left: 80px;
    position: relative;

    .firstTit {
      font-size: 2.3rem;
      margin-top: 20px;
      cursor: pointer;
    }

    .firstTit:hover {
      color: #EDAC1A;
    }

    .activedMenu {
      color: #EDAC1A;
    }

    .childBox {
      color: white;
      cursor: pointer;
      font-size: 1.5rem;

      .childrenTit {
        padding-bottom: 3px;
        margin-left:20px;
      }
      .childrenTitT {
        padding-bottom: 3px;
        font-size:2rem;
        margin-left:10px;
      }
    }

    .childBox:hover .childrenTit {
      
      padding-bottom: 2px;
      
    }

    .childBox:hover .childrenTitT {
      color: #EDAC1A;
      padding-bottom: 2px;
      
    }

    .openChild {
      display: block;
    }

    .closeChild {
      display: none;
    }
  }
}

.openMean {
  animation: slide-in-left 0.5s;
  animation-fill-mode: forwards;
}

@keyframes slide-out-left {
  0% {
    right: 0;
  }

  100% {
    right: -350px;
  }
}

@keyframes slide-in-left {
  0% {
    right: -350px;
  }

  100% {
    right: 0px;
  }
}

@media (max-width: 768px) {
  .logo {
    z-index: 999;
    width: 25vw;
    margin-left: 5vw;
  }

  .bg {
    padding: 0;
  }

  .meS {
    width: 20px !important;
    height: 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navTemp/index.vue